import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { getToken } from '../utils/auth';
import { useDraftOrderActionModals } from '../hooks/useDraftOrderActionModals';
import { useExpirationStatus } from '../hooks/useExpirationStatus';
import LineItem from './other/LineItem';
import DraftOrderStatusPills from './other/DraftOrderStatusPills';
// import ModalShareQuote from '../components/modals/ModalShareQuote';


// import DraftOrderStatusPills from './other/DraftOrderStatusPills';
// import DraftOrderHeader from './other/DraftOrderHeader';
import { useFormatUSD } from '../../utils/formatting';
import { goToPortal, orderUrl } from '../utils/portalLinks';
// import { PdfIcon } from '../../utils/icons';
// import { BsSend } from "react-icons/bs";
// import { FaRegFilePdf } from 'react-icons/fa6';

// import { RESTRICTED_VENDORS, NO_UPDATE_QTY_PRODUCT_TYPES, ONLY_QTY_PRODUCT_TYPES } from '../../utils/constants';

function DraftOrderCardExpandable({ draftOrder, index, onOrderRemoved, showModal, filterBy }) {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  // const [isExpanded, setIsExpanded] = useState(index === 0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedAttributes, setExpandedAttributes] = useState(new Set());

  const [modalContent, setModalContent] = useState(null);
  // const [lineItemsExpanded, setLineItemsExpanded] = useState(false);

  // Calculate expiration status
  const { expired, expirationColorClass, expirationText, expirationTextClass } = useExpirationStatus(draftOrder.expirationDate);

  const order = draftOrder.order;
  const isOrder = order?.id;
  // const createdAt = isOrder ? order.createdAt : draftOrder.createdAt;
  const total = isOrder ? order.totalPrice : draftOrder.totalPrice;
  const showExpired = !isOrder && expired;

  // Expand the first visible quote whenever the list (index) or filter changes
  // useEffect(() => {
  //   setIsExpanded(index === 0);
  // }, [index, filterBy]);
  

  const removeCard = () => {
    if (cardRef.current) {
      cardRef.current.style.opacity = '0';
      cardRef.current.style.transform = 'scale(0.95)';
      setTimeout(() => onOrderRemoved(draftOrder.id), 300);
    }
  };

  // const showModal = (content) => {
  //   setModalContent(content);
  // };

  const closeModal = () => {
    setModalContent(null);
  };

  const { handleApprove, handleDecline, handleRequestUpdates, handleRequestExtension, handleAskQuestion } = useDraftOrderActionModals({
    showModal,
    orderId: draftOrder.id,
    onComplete: removeCard,
    quoteName: draftOrder?.name || draftOrder?.order?.name,
    // canPayByPo: customerCanPayByPo(draftOrder?.customer?.tags),
    customerEmail: draftOrder?.customer?.email,
  });

  const handleViewDetails = () => {
    // Converted quotes live on the order portal; in-app navigate would only change
    // the hash while staying on /pages/quote-portal/.
    if (draftOrder.order?.id) {
      goToPortal(orderUrl(draftOrder.order.id));
      return;
    }
    navigate(`/draft-order/${draftOrder.id}`);
  };

  // const handleToggleCollapsible = () => {
  //   setIsExpanded(prev => !prev);
  // };

  const toggleAttributesExpanded = (index) => {
    setExpandedAttributes(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const sortedLineItems = useMemo(() => {
    const items = draftOrder.lineItems || [];
    return items
      .map((item, originalIdx) => ({ item, originalIdx }))
      .sort((a, b) => {
        // const aRestricted = RESTRICTED_VENDORS.includes(a.item.vendor);
        // const bRestricted = RESTRICTED_VENDORS.includes(b.item.vendor);
        // if (aRestricted && !bRestricted) return 1;
        // if (!aRestricted && bRestricted) return -1;

        // same restriction group → sort by title
        const titleA = (a.item.title || '').toLowerCase();
        const titleB = (b.item.title || '').toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
  }, [draftOrder.lineItems]);

  const isCancelledOrder = isOrder && !!draftOrder.order?.cancelledAt;
  const showQuoteNumber = isOrder && !isCancelledOrder && !!draftOrder.order?.name;
  const clickableProps = handleViewDetails ? { onClick: handleViewDetails } : {};

  return (
    <div 
      ref={cardRef}
      className={`draft-order card card-expandable draft-${draftOrder.status.toLowerCase()} ${draftOrder.order?.cancelledAt ? 'order-cancelled' : ''}`}
      style={{ animationDelay: `${index * 0.05}s` }}
    >

      {/* <DraftOrderHeader
        draftOrder={draftOrder}
        expired={expired}
        expirationColorClass={expirationColorClass}
        expirationText={expirationText}
        onClick={handleViewDetails}
      /> */}

      <button
        className="card__collapsible-button"
        data-action="toggle-collapsible"
        aria-expanded={isExpanded}
        aria-controls={`draft-order-${draftOrder.id}`}
        data-close-siblings="false"
        // onClick={handleToggleCollapsible}
      >
        <span className="card__title expandable-title" {...clickableProps}>
          <div className="draft-order-title" >
          <span className="order-name heading h3" >
            {isOrder ? (
              <>
                Order {order.name} {showQuoteNumber && <span className="quote-number">&nbsp;-&nbsp;(Quote {draftOrder.name})</span>}
              </> 
            ) : (
              <>Quote {draftOrder.name}</>
            )}
            </span>
          </div>

          <DraftOrderStatusPills
            draftOrder={draftOrder}
            expired={showExpired}
            expirationColorClass={expirationColorClass}
            expirationText={expirationText}
            className="draft-order-status-expandable"
          />
        </span>

        
        <div className="total-amount-header">
          <span>Total: <strong className="total-amount-value">{useFormatUSD(total)}</strong></span>
          <div className="items-count">({draftOrder.lineItems.length} Item{draftOrder.lineItems.length > 1 ? 's' : ''})</div>
        </div> 
        

        <span className="plus-button plus-button--large"></span>
      </button>


      <div className={`card__collapsible ${isExpanded ? 'expanded' : ''}`} id={`draft-order-${draftOrder.id}`}>

        <div className="line-items">
          {sortedLineItems.map(({ item, originalIdx }) => (
            <LineItem
              key={originalIdx}
              item={item}
              index={originalIdx}
              variant="card"
              expandThreshold={3}
              isExpanded={expandedAttributes.has(originalIdx)}
              onToggleExpand={toggleAttributesExpanded}
              showManual={true}
            />
          ))}
        </div>


        <div className="order-summary-expandable">
          {/* <div className="summary-row">
            <span className="strong">Subtotal</span>
            <span>{useFormatUSD(draftOrder.lineItemsSubtotalPrice)}</span>
          </div>
          {parseFloat(draftOrder.totalTax) > 0 && (
            <div className="summary-row">
              <span className="strong">Tax</span>
              <span>{useFormatUSD(draftOrder.totalTax)}</span>
            </div>
          )}
          {parseFloat(draftOrder.appliedDiscount) > 0 && (
            <div className="summary-row">
              <span className="strong">Discount {draftOrder.appliedDiscountTitle}</span>
              <span>- {useFormatUSD(draftOrder.appliedDiscount)}</span>
            </div>
          )}
          {parseFloat(draftOrder.totalShippingPrice2) > 0 && (
            <div className="summary-row">
              <span className="strong">{draftOrder.totalShippingName}</span>
              <span>{useFormatUSD(draftOrder.totalShippingPrice2)}</span>
            </div>
          )} */}
          <div className="summary-row total">
            <span className="summary-label">Total</span>
            <strong className="total-amount-value">{useFormatUSD(draftOrder.totalPrice)}</strong>
          </div>

          {/* {(draftOrder.order?.invoicePdf || draftOrder.quote_pdf) && (
            <a className="quote-pdf-link" href={draftOrder.order?.invoicePdf || draftOrder.quote_pdf} target="_blank" rel="noopener noreferrer">
              Download PDF <PdfIcon strokeWidth={3} />
            </a>
          )} */}



          {((draftOrder.status === 'OPEN_QUOTE') || (draftOrder.order && !draftOrder.order?.cancelledAt)) && (
            <div className="order-actions order-actions-expandable">


              {!draftOrder.order?.cancelledAt && (
                <button className="button button--primary button--bordered" {...clickableProps}>View Details</button>
              )}

              {/* {!expired && draftOrder.status === 'OPEN_QUOTE' ? (
                <button
                  className="button button--share button--bordered"
                  onClick={() => showModal(
                    <ModalShareQuote
                      title={draftOrder.order?.name && !draftOrder.order?.cancelledAt ? `Share Order ${draftOrder.order?.name}` : `Share Quote ${draftOrder.name}`}
                      orderId={draftOrder.order?.id || draftOrder.id}
                      token={getToken().token}
                      quoteName={draftOrder.order?.name || draftOrder.name}
                      onClose={closeModal}
                    />
                  )}
                >
                  Share {draftOrder.order?.name ? `Order` : `Quote`}
                </button>
              ) : null} */}

              {expired && draftOrder.status !== 'COMPLETED' ? (
                <button onClick={handleRequestExtension} className="button button--secondary button--bordered">Request Extension</button>
              ) : null}

              

              {/* <button
                className="button button--primary button--bordered"
                onClick={handleApprove}
                disabled={isProcessing}
              >
                {isProcessing ? 'Processing...' : 'Approve Quote'}
              </button>
              <button
                className="button button--secondary button--bordered"
                onClick={handleRequestUpdates}
                disabled={isProcessing}
              >
                Request Updates
              </button>
              <button
                className="button button--danger button--bordered"
                onClick={handleDecline}
                disabled={isProcessing}
              >
                Decline
              </button> */}

              
            </div>
          )}
          

            


          
          
        </div>

       

      </div>
    </div>
  );
}

export default DraftOrderCardExpandable;
